module.exports = __webpack_public_path__ + "img/number.7e0faaa5.svg";